import { usePathname, useRouter } from '@/navigation';
import { Button } from '@nf/ui';
import { MyBetIcon } from '@/components/icons/svg-icons';
import { Tip } from '@/features/sidebar/components/sidebar-item';
import { setKafkaNormal, setNormalKafkaBody } from '@/hooks/query/use-kafka-log';
import { routerService } from '@/services/router.service';
import { useLocale } from 'next-intl';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { KafkaNote } from '@nf/utils-common/constants';

type MyBetsButtonProps = {
	from?: 'header' | 'single-match'
}

export const MyBetsButton = ({ from }: MyBetsButtonProps) => {
	const router = useRouter();
	const locale = useLocale();
	const pathName = usePathname();
	const view = useAppearanceStore(state => state.view);

	const goToMyBets = () => {
		setKafka();
		routerService.push(router.push, locale, '/bets/u', pathName);
	};

	const setKafka = () => {
		if (view !== ViewEnum.galaxy) return;

		const kafkaData = {
			note: KafkaNote.GalaxyV2
		} as setNormalKafkaBody;

		switch (from) {
			case 'header':
				kafkaData.type = 1;
				kafkaData.action = 4;
				break;
			case 'single-match':
				kafkaData.type = 9;
				kafkaData.action = 7;
				break;
		}

		if (kafkaData.action) {
			setKafkaNormal(kafkaData);
		}
	}

	return (
		<>
			<Button
				variant="icon"
				className="btn--mybet"
				onClick={goToMyBets}
			>
				<MyBetIcon />
			</Button>
			<Tip className="tip tip--right" auto={true} />
		</>
	);
};